import React from "react";

type DirectDebitColorProps = React.SVGProps<SVGSVGElement>;

// "Lastschrift" (SEPA direct debit) is a payment method, not a brand — rendered as a
// bordered wordmark badge, matching RechnungColor.
const DirectDebitColor: React.FC<DirectDebitColorProps> = (props) => (
  <svg viewBox="0 0 116 32" role="img" fill="none" {...props}>
    <title>Lastschrift</title>
    <rect
      x="1"
      y="1"
      width="114"
      height="30"
      rx="4"
      fill="#FFFFFF"
      stroke="#1A1918"
      strokeWidth="2"
    />
    <text
      x="58"
      y="21"
      textAnchor="middle"
      fontFamily="heebo, roboto, arial, helvetica, sans-serif"
      fontSize="15"
      fill="#1A1918"
    >
      Lastschrift
    </text>
  </svg>
);

export default DirectDebitColor;
